import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			// loader-tai-chi-yoga-m
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Tai Chi Plan For Glucose Reduction Based on Your Age',
					size: 'small',
					customStyles: {
						marginLeft: '2rem',
						marginRight: '2rem',
					},
				}),
			},
		},
		{
			// age-tai-chi-yoga-m-pr
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Tai Chi for Glucose Reduction',
					size: 'large',
					uppercase: true,
					customStyles: {
						marginTop: '2rem',
					},
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
